<template>
  <PDrawerTab
    :results-count="ongoingChatsCount"
    :tab-counters="loggedStaffCounters.chats"
    @load="fetchChannels({ setCurrentPage: false })"
  >
    <PDrawerHeaderFilters
      allow-search
      allow-filter
      @filter:change="fetchChannels"
      @sort:change="fetchChannelsChats"
    />
    <PDrawerList
      v-if="hasPermissionToGetChat"
      is-emergency
      title="Novos atendimentos"
      :list="newChats"
      empty-icon="flipflop"
      empty-message="Não existem novos atendimentos"
      :total="totalNewChats"
      :show-offline-message="!isLoggedStaffOnline"
    />

    <PDrawerList
      title="Favoritos"
      hide-no-results
      :list="highlightedOngoingChats"
      :total="loggedStaffCounters.chats.totalHighlighted"
    />

    <PDrawerList
      title="Em andamento"
      empty-icon="tea"
      empty-message="Não existem chats em andamento"
      :list="ongoingChatsWithoutHighlight"
      :total="loggedStaffCounters.chats.total"
    />
  </PDrawerTab>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { CHANNEL_KINDS } from '@/models/channels'

import PDrawerHeaderFilters from '../PDrawerHeaderFilters.vue'
import PDrawerList from '../PDrawerList.vue'
import PDrawerTab from '../PDrawerTab.vue'

export default {
  components: {
    PDrawerHeaderFilters,
    PDrawerList,
    PDrawerTab
  },
  data() {
    return {
      listener: undefined
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'hasPermissionToGetChat']),
    ...mapGetters('channel/drawer', [
      'ongoingChatsCount',
      'ongoingChatsWithoutHighlight',
      'highlightedOngoingChats'
    ]),
    ...mapState('channel/drawer', ['currentFilters', 'newChats']),
    ...mapGetters('channel/staff', [
      'loggedStaffCounters',
      'isLoggedStaffOnline'
    ]),
    totalNewChats() {
      return this.newChats?.length
    }
  },
  watch: {
    'currentFilters.tags': 'fetchChannels'
  },
  beforeUnmount() {
    if (this.listener) this.listener()
    this.$store.commit('channel/drawer/setCurrentPage', 0)
    this.$store.commit('channel/drawer/setOngoingChats', undefined)
  },
  methods: {
    async fetchChannels({ setCurrentPage = true } = {}) {
      if (setCurrentPage) {
        this.$store.commit('channel/drawer/setCurrentPage', 1)
      }

      if (this.listener) this.listener()

      this.listener = await this.$store.dispatch(
        'channel/drawer/fetchChannels',
        {
          mutation: 'setOngoingChats',
          kind: CHANNEL_KINDS.CHAT
        }
      )
    },
    fetchChannelsChats(data) {
      this.fetchChannels(data)
      this.$store.dispatch('channel/drawer/fetchChats')
    }
  }
}
</script>
